import React, {useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import {invalidateRefreshToken} from "../../utils/storage";
import {LOGIN_PAGE} from "../../router";
import {getRedirectUriParam, hasParameter, REDIRECT_QUERY_PARAMETER_KEY} from "../../utils/queryparam";
import { FormattedMessage } from 'react-intl';

const LogoutPage = () => {

    const navigate = useNavigate();

    useEffect(() => {
        invalidateRefreshToken();
        let redirectTo = `${LOGIN_PAGE}?logout`;
        if (hasParameter(REDIRECT_QUERY_PARAMETER_KEY)) redirectTo += `&${REDIRECT_QUERY_PARAMETER_KEY}=${getRedirectUriParam()}`
        navigate(redirectTo, { replace: true });
    })

    return <><FormattedMessage id="logoutRedirection" /></>
}

export default LogoutPage;